import PropTypes from 'prop-types';

import Box, { BoxProps as MuiBoxProps } from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { Stack, Typography } from '@mui/material';
import {
  AppointmentSelection,
  CycleIcon,
  MiniProfile,
  NoMatchBanner,
} from '@classity-edtech/ui-base/dist/components/Displays';
import { Dayjs } from 'dayjs';
import { Appointments } from '@classity-edtech/ui-base/dist/components/Displays/Appointments/Appointments';
import { Fragment, ReactNode } from 'react';
import { ApplicationStatus } from '@classity-edtech/platform-utils';

type ProfileType = {
  src?: string;
  name?: string;
  rating?: number;
  followers?: number;
  tabs?: { label: string; active: boolean; action: () => void }[];
};

type AppointmentSelectionType = {
  selectionActions: {
    dateTime: (Date | String)[];
    dateValue: Dayjs;
    highlightedDays: (Date | String)[];
    setDateValue: (value: Dayjs) => void;
    setTimeValue: (value: Dayjs | string) => void;
    timeValue: Dayjs;
  }[];
  radioOptions: {
    label: string;
    name: string;
    onChange: () => void;
  }[];
  radioValue: string;
  title: string;
  actionTitle: string;
  appointmentActions: {
    label: string;
    variant: string;
    action: () => void;
  }[];
};

type AppointmentsType = {
  appointments: {
    appointmentDay: string;
    appointmentDate: string;
    appointmentTime: string;
    appointmentLocation: React.ReactNode;
    appointmentInfo: string;
    appointmentAvatars: string[];
    cancelAction: (index: number) => void;
    clickAction: () => void;
  }[];
  title: string;
}[];

export interface HomeProps extends MuiBoxProps {
  summary: string;
  profile: ProfileType;
  appointmentSelection: AppointmentSelectionType;
  appointments: AppointmentsType;
  applicationData?: any;
  refetchApplications?: () => {};
}

export const UserAvailability = ({
  summary,
  profile,
  appointmentSelection,
  appointments,
  applicationData,
  refetchApplications,
  className,
}: HomeProps) => {
  return (
    <Box className={className}>
      <MiniProfile {...profile} />
      {applicationData?.applicationStatus === ApplicationStatus.INPROGRESS && (
        <>
          <Typography variant='body3' sx={{ mt: 1 }}>
            {summary}
          </Typography>
          <Box sx={{ my: 2 }}>
            <AppointmentSelection {...(appointmentSelection as any)} />
          </Box>
        </>
      )}
      {applicationData?.interviewDates?.length &&
        applicationData?.interviewDates?.every(a => !a.confirmed) && (
          <Stack sx={{ alignItems: 'center' }}>
            <NoMatchBanner sx={{ width: '170px', height: '130px' }} />

            <Typography variant='subtitle5'>RSVP to be confirmed</Typography>

            <Typography variant='body3'>Invitation for interview has yet to be accepted</Typography>

            <Box
              sx={{ display: 'flex', alignItems: 'center', gap: 0.5, cursor: 'pointer' }}
              onClick={refetchApplications}
            >
              <CycleIcon />
              <Typography variant='body3'>Refresh</Typography>
            </Box>
          </Stack>
        )}
      <Stack sx={{ gap: 2 }}>
        {appointments?.map((appointment, i) => (
          <Fragment key={i}>
            <Appointments {...(appointment as any)} />
          </Fragment>
        ))}
      </Stack>
    </Box>
  );
};

UserAvailability.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

UserAvailability.defaultProps = {
  children: null,
  className: null,
};

export default styled<any>(UserAvailability)(
  ({ theme }) => `
`,
);
